import { useCallback } from 'react';
import { useDispatch, useSelector } from '@meiqia/store/react-redux';
import { updateNotificationCount } from '../../../reducers/notification';
import { getNewNotificationNum } from '../api';
import { isHiddenFn } from '@/utils/bespoke-config/config';

const useNotificationCount = () => {
  const dispatch = useDispatch();
  const newNotificationCount = useSelector(state => state.getIn(['notification', 'count']));

  const refreshNotificationCount = useCallback(() => {
    if (isHiddenFn('notification_ticket_api')) {
      return;
    }
    getNewNotificationNum().then(res => dispatch(updateNotificationCount({ count: res.data.data })));
  }, []);

  /**
   * 手动设置notification.count
   * @params count: number | (prevCount: number) => number
   */
  const setNotificationCount = useCallback(count => {
    dispatch(updateNotificationCount({ count }));
  }, []);

  return { newNotificationCount, refreshNotificationCount, setNotificationCount };
};

export default useNotificationCount;
